// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceAnchoredWorkCard-cls1_2Ac","cls2":"SourceAnchoredWorkCard-cls2_q7s SourceAnchoredWorkCard-cls1_2Ac"};